<i18n>
	{
		"en": {
			"welcome": "Welcome"
		},
		"fr": {
			"welcome": "Bienvenue"
		}
	}
</i18n>

<template>
	<!-- Navbar -->
	<b-navbar toggleable="md" type="light" variant="secondary" fixed='top'>

	<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

	<b-navbar-brand href="#" class="d-none d-md-inline"><img src="../assets/unilogo.png" style="margin-right:5px;" height="58" width="156"></b-navbar-brand>
	<b-navbar-brand href="#" class="d-none d-md-inline"><img src="../assets/epfllogo.png" style="margin-right:5px;" height="58" width="132"></b-navbar-brand>
	
	<h2><router-link to="/" style = 'font-size: 1.5rem;' class = 'navbar-brand'>BI<span class="cc">ƆC</span><span class="d-none d-md-inline"> | BioInformatics Ɔompetence Center</span></router-link></h2>

	<b-collapse is-nav id="nav_collapse">

	<!-- Right aligned nav items -->
	<b-navbar-nav class="ml-auto">

	<b-navbar-nav right style="z-index:100">
	<b-nav-item v-access = '"active"'><router-link to="/timesheet" class = 'navbar-brand'><v-icon name = "calendar-check" scale="1"></v-icon><span class="ml-2">Timesheets</span></router-link></b-nav-item>
	<b-nav-item v-access = '"active"'><router-link :to="user.permissions && user.permissions.indexOf('admin')>-1?'/admin':'/myprojects'" class = 'navbar-brand'><v-icon name = "cogs" scale="1"></v-icon><span class="ml-2">{{user.permissions && user.permissions.indexOf('admin')>-1?"Admin":"My Projects"}}</span></router-link></b-nav-item>
	<b-nav-item v-access = '"!active"'><router-link to="/login" class = 'navbar-brand'>Login (private)</router-link></b-nav-item>
	<b-nav-item v-access = '"active"'><router-link to="/" class = 'navbar-brand'>{{$t('welcome')}} {{user.username}}</router-link></b-nav-item>
	<b-nav-item v-access = '"active"'><router-link to="/login" class = 'navbar-brand'><v-icon name = 'sign-out-alt'></v-icon></router-link></b-nav-item>
	<b-nav-item-dropdown :text="'Lang: '+lang" right v-if='multilang'>
	<b-dropdown-item @click="changeLang('en')">EN</b-dropdown-item>
	<b-dropdown-item @click="changeLang('fr')">FR</b-dropdown-item>
</b-nav-item-dropdown>
</b-navbar-nav>

</b-navbar-nav>

</b-collapse>
</b-navbar>

</template>
<script>

import { mapGetters } from 'vuex'
import { multilang, siteTitle } from '@/app_config'

export default {
	name: 'navHeader',
	data () {
		return {
			multilang: multilang,
			siteTitle: siteTitle
		}
	},
	computed: {
		...mapGetters({
			user: 'currentUser'
		}),
		lang () {
			return this.$i18n.locale
		},
		currentProject () {
			return this.user.projects.filter(p => p.project_id == this.user.project_id)[0];
		}
	},
	methods: {
		setProject (project){
			this.$store.dispatch('setProject',project).then(() => {
				this.$router.go();
			});
		},
		changeLang (value) {
			this.$root.$i18n.locale = value
		}
	}

}

</script>

<style scoped>
span.cc{
	letter-spacing: -3px;
}

h2 {
	text-align: center;
	width: 100%;
	margin: auto;
	position: absolute;
	z-index: 1;
}
</style>

